import { BrandSettings, BrandSettingsFetchOptions } from "../models/types";
import queryClient, { QueryKey } from "../state/QueryStore";
import { ListResponse } from "../utilities/ApiResponseHelper";
import { httpGetAuthenticated, httpPatchAuthenticated, httpPostAuthenticated } from "./ApiService";

const endpoints = {
  list: () => "/brand_settings",
  retrieve: (id: string) => `/brand_settings/${id}`,
};

export const getBrandSettings = (params: BrandSettingsFetchOptions) => {
  return httpGetAuthenticated<ListResponse<BrandSettings>>(endpoints.list(), {
    params,
  });
};

export const addBrandSettings = async (payload: {
  primary_color: string | null;
  secondary_color: string | null;
  logo: File | null;
}) => {
  const formData = new FormData();
  if (payload.primary_color) {
    formData.append("primary_color", payload.primary_color);
  }
  if (payload.secondary_color) {
    formData.append("secondary_color", payload.secondary_color);
  }

  if (payload.logo) {
    formData.append("logo", payload.logo);
  }
  const { data } = await httpPostAuthenticated<BrandSettings>(endpoints.list(), formData);
  queryClient.invalidateQueries({ queryKey: [QueryKey.BrandSettings] });
  return data;
};

export const editBrandSettings = async (
  objectId: string,
  payload: {
    primary_color: string | null;
    secondary_color: string | null;
    logo: File | null;
    removeLogo: boolean;
  }
) => {
  const formData = new FormData();
  formData.append("primary_color", payload.primary_color ?? "");
  formData.append("secondary_color", payload.secondary_color ?? "");

  if (payload.logo) {
    formData.append("logo", payload.logo);
  } else if (payload.removeLogo) {
    formData.append("logo", "");
  }
  const { data } = await httpPatchAuthenticated(endpoints.retrieve(objectId), formData);
  queryClient.invalidateQueries({ queryKey: [QueryKey.BrandSettings] });
  return data;
};
